<div class="report-container container-fluid">
  <ng-container
    *ngIf="showReportsListLoading$ || userInfo$ | async; else content">
    <div
      class="d-flex align-items-center justify-content-center flex-column flex-grow-1"
      style="min-height: 50vh">
      <mat-spinner
        class="loading-spinner"
        strokeWidth="6"
        diameter="75"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #content>
    <div *ngIf="reportsList?.length; else no_data">
      <app-report-item
        *ngFor="let report of reportsList; index as i"
        [details]="report"
        [slide]="report.selected ? 'in' : 'out'"
        (onReportSelect)="onReportSelect($event)"
        (onReportRun)="onFormSubmit($event)"></app-report-item>
    </div>
    <ng-template #no_data>
      <div class="container-fluid sub-nav no-data-container">
        <div class="book-demo-container row">
          <div class="book-demo-content col-12 col-md-6">
            <h3>
              <span>Unlock the power of data</span> with Reporting and Analytics
              feature in your customer portal! Gain
              <span>deeper insights</span> into your waste diversion rates,
              recycling trends, and overall waste performance.
            </h3>
            <ul>
              <li>
                See where you can optimize your waste management strategy.
              </li>
              <li>
                Use YTD data to improve and inform sustainability efforts.
              </li>
            </ul>
            <h4>
              Upgrade your customer portal access today and unlock a world of
              valuable waste reporting metrics!
            </h4>
            <button
              class="col-12 col-sm-auto"
              mat-raised-button
              color="accent"
              (click)="openBookADemoDialog()">
              Book a Demo
            </button>
          </div>
          <div
            class="book-demo-ad-image col-12 col-md-6 d-none d-sm-flex"></div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
